import plusButton from '../../images/icons/plus-icon.png'
import { useFirestore, useFirestoreID, useFirestoreOrderBy, useFirestoreGeneralOrderBy } from "../../firebase/useFirestore";
import { useState, useContext, useEffect, useMemo, useRef } from "react";
import { client } from '../../hooks/Client';
import uuid from "react-uuid";
import deleteIcon from '../../images/icons/delete-icon.png'
import { db, timestamp } from "../../firebase/config.js"
import ScrollToTop from "../../hooks/ScrollToTop";
import { SavedIcon } from "../../StateManagment/SavedIcon";
import Location from "../../hooks/Location"
import MeasureMoment from "../../components/Research/MeasureMoment";
import Tooltip from "../../components/common/Tooltip";
import { Auth } from "../../StateManagment/Auth";
import useSettings from "../../hooks/Settings";
import { useHistory } from "react-router-dom";
import Modal from 'react-modal';
import EditIcon from '@mui/icons-material/EditOutlined';
import PageHeader from "../../components/layout/PageHeader.jsx";
import PageNotice from "../../components/layout/PageNotice";
import ToggleButton from "../../components/common/ToggleButton";
import isFlagOn from "../../helpers/isFlagOn";
import ConfirmModal from "../../components/common/Modal";
import probeHasResponses from "../../helpers/questionnaires/probeHasResponses";
import ResearchAppliesToSettings from "../../components/Research/ResearchAppliesToSettings.jsx";
import { syncQualifyingExclusions } from "../../helpers/questionnaire/applyQualifyingToggle";
import PremiumIcon from '../../components/common/PremiumIcon.jsx';
import TargetgroupMeta from "../../components/stakeholders/TargetgroupMeta.jsx";
import ReadOnlyGuard from "../../components/common/ReadOnlyGuard";
import isQuestionField from "../../helpers/questionnaire/isQuestionField";

const ResearchBuilder = () => {
    // Context
    const [saved, setSaved] = useContext(SavedIcon)
    const [auth] = useContext(Auth)

    // State
    const [questionnaireID, setQuestionnaireID] = useState('')
    const [isOpen, setIsOpen] = useState(false);
    const [showTable, setShowTable] = useState('none')
    const [editTargetgroup, setEditTargetgroup] = useState('none')
    const [editQuestionnaire, setEditQuestionnaire] = useState('none')

    // Hooks
    const route = Location()[3]
    ScrollToTop()
    const {
            AIInterviewerOn: AIinterviewerOn,
        subscription,
    } = useSettings()
    const history = useHistory()
    Modal.setAppElement('#root');
    const modalStyles = {
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
      },
    };

    // Firestore
    const researches = useFirestoreID('Research', route ? route : '123')
    const questionnaires = useFirestoreOrderBy('Questionnaires', 'Position', 'asc')
    const measureMomentsRaw = useFirestoreGeneralOrderBy('MeasureMoments', 'ResearchID', route ? route : '123', 'Position', 'asc')
    const measureMoments = useMemo(() => (measureMomentsRaw || []).filter((m) => !m.Deleted), [measureMomentsRaw])
    const fields = useFirestore('QuestionnaireFields')
    // De velden van één vragenlijst uit de listener hierboven, voor de
    // herberekening van de kwalificeringsvragen; nog aan het laden = undefined,
    // dan leest die herberekening zelf (performancecheck /complete 2026-10-28).
    /** @param {string} id @returns {Array<object> | undefined} */
    const fieldsOf = (id) => (Array.isArray(fields) ? fields.filter((f) => f.QuestionnaireID === id) : undefined)
    const stakeholders = useFirestore('Stakeholders')

    // Delete research (soft delete, ADR-008)
    const deleteResearch = (e) => {
        const docid = e.currentTarget.dataset.docid

        db.collection('Research')
        .doc(docid)
        .update({
            Deleted: true,
            DeletedAt: timestamp,
            DeletedBy: auth?.ID || '',
        })

    }


    // Hide the table when there is no questionnaire selected
    const hideTable = () => {
        if(measureMoments && measureMoments.length > 0){
            setShowTable('none')
        } else {
            setShowTable('block')
        }
    }

    useEffect(() => {
        hideTable()
    }, [researches])

    // Set researchmeta in state
    useEffect(() => {
        researches && researches.map(research => (
            setQuestionnaireID(research.QuestionnaireID)
        ))
    }, [researches])

    // Add measure moment
    const addMoment = (e) => {

        const questionnaireID = e.currentTarget.dataset.questionnaireid
        const researchID = e.currentTarget.dataset.researchid
        const researchTitle = e.currentTarget.dataset.researchtitle

        const position = measureMoments.length + 1

        db.collection('MeasureMoments')
        .doc()
        .set({
            ResearchID: researchID,
            ResearchTitle: researchTitle,
            Moment: new Date(),
            Title: '',
            ID: uuid(),
            Compagny: client,
            CompagnyID: client,
            Timestamp: timestamp,
            QuestionnaireID: questionnaireID,
            Responses: 0,
            Position: position
        })
        // Een nieuw meetmoment krijgt de kwalificeringsvragen uit (of, als het
        // het eerste is, juist aan). AI-CONTEXT: See docs/features/sector-kwalificeringsvragen.md
        .then(() => syncQualifyingExclusions({ questionnaireId: questionnaireID, client, fields: fieldsOf(questionnaireID) }))
    }

    // Select questionnaire
    const selectQuestionnaire = (e) => {
        const questionnaireID = e.target.options[e.target.selectedIndex].dataset.id
        const title = e.target.options[e.target.selectedIndex].dataset.title
        const docid = e.target.dataset.researchdocid

        console.log('Select questionnaire', questionnaireID, docid)

        db.collection('Research')
        .doc(docid)
        .update({
            QuestionnaireID: questionnaireID || '',
            QuestionnaireTitle: title || ''
        })
        .then(() => {
            setSaved('flex')
            // De nieuwe vragenlijst kan kwalificeringsvragen hebben: zet ze uit op
            // de latere meetmomenten. AI-CONTEXT: See docs/features/sector-kwalificeringsvragen.md
            return syncQualifyingExclusions({ questionnaireId: questionnaireID || '', client, fields: fieldsOf(questionnaireID) })
        })
    }

    // Connect questionnaire to research
    const connectQuestionnaire = (questionnaireID, questionnaireTitle, docid) => {

        console.log('Connect questionnaire', questionnaireID, questionnaireTitle, docid)

    db.collection('Research')
        .doc(docid)
        .update({
            QuestionnaireID: questionnaireID,
            QuestionnaireTitle: questionnaireTitle

        })
        .then(() => {
            setSaved('flex')
            setIsOpen(false);
            setEditQuestionnaire('none')
        })
    }

    // Create questionnaire
    const addQuestionnaireHandler = async (e) => {

        const docid = e.target.dataset.docid
        const researchTitle = e.target.dataset.researchtitle

        const questionaireId = uuid()
        const title = `Vragenlijst onderzoek ${researchTitle}`

        await db.collection('Questionnaires')
        .doc()
        .set({
            Compagny: client,
            CompagnyID: client,
            ID: questionaireId,
            Timestamp: timestamp,
            Title: title,
            Description: '',
            Position: questionnaires.length + 1
        })

        connectQuestionnaire(questionaireId, title, docid)

    }

    // Change research title
    const changeResearchTitle = (e) => {
        const docid = e.target.dataset.docid
        const title = e.target.value

        db.collection('Research')
        .doc(docid)
        .update({
            Title: title
        })
        .then(() => {
            setSaved('flex')
         })
    }

    // Change targetgroup
    const changeTargetgroupHandler = (e) => {
            
        const targetgroupID = e.target.options[e.target.selectedIndex].value
        const targetgroupTitle = e.target.options[e.target.selectedIndex].dataset.title
        const docid = e.target.dataset.docid

        db.collection('Research')
        .doc(docid)
        .update({
            TargetgroupID: targetgroupID,
            TargetgroupTitle: targetgroupTitle

        })
        .then(() => {
            setSaved('flex')
            setEditTargetgroup('none')
        })
    }

    // Helper function to normalize the values for the SendCopyOption setting
    const normalize = v => {
        if (v === 'on'  || v === true  || v === 'true')  return 'true';
        if (v === 'off' || v === false || v === 'false') return 'false';
        return '';
      };

    // Schuifbalk aanzetten op een onderzoek dat al antwoorden heeft: eerst vragen.
    // Anders vergelijk je rondjes- en schuifbalkantwoorden zonder het te weten
    // (testronde 2026-10-15, B3). Alleen gelezen bij het AANzetten, niet bij elke
    // paginalading. Mislukt de lezing, dan vragen we ook: 'weet ik niet' is geen 'nee'.
    const [vasConfirmOpen, setVasConfirmOpen] = useState(false)
    /** @type {React.MutableRefObject<((ok: boolean) => void) | null>} */
    const vasAnswerRef = useRef(null)

    const answerVasConfirm = (ok) => {
        const resolve = vasAnswerRef.current
        vasAnswerRef.current = null
        setVasConfirmOpen(false)
        if (resolve) resolve(ok)
    }

    /** @param {string} researchID @returns {Promise<boolean>} */
    const confirmVasOn = async (researchID) => {
        let hasAnswers
        try {
            hasAnswers = await probeHasResponses('ResearchID', researchID)
        } catch (error) {
            console.error('Kon niet nagaan of dit onderzoek al antwoorden heeft:', error)
            hasAnswers = true
        }
        if (!hasAnswers) return true
        return new Promise((resolve) => {
            vasAnswerRef.current = resolve
            setVasConfirmOpen(true)
        })
    }

    // Aantal vragen in de vragenlijst, als tekst. Een sectiekop is een gewoon
    // QuestionnaireFields-document maar geen vraag (testronde 2026-10-28, B1).
    const questionCountLabel = (questionnaireID) => {
        const count = fields.filter(item => item.QuestionnaireID === questionnaireID && isQuestionField(item)).length
        return `${count} ${count === 1 ? 'vraag' : 'vragen'}`
    }

  return (
    <div className="main">
        <div className="main-container" >
            <PageHeader 
                heading={'Onderzoek instellingen'}
                description={`Hier kun je de onderzoeken aanpassen. Voeg meetmomenten toe en koppel een vragenlijst.`}
            />
            <PageNotice 
                text={<span dangerouslySetInnerHTML={{ __html: 'Vergeet niet om de vragenlijsten aan te passen nadat je er een hebt aangemaakt' }} />}
            />
            <ConfirmModal
                modalOpen={vasConfirmOpen}
                setModalOpen={(open) => { if (!open) answerVasConfirm(false) }}
                confirm={() => answerVasConfirm(true)}
                confirmLabel='Toch aanzetten'
                pageHeader='Schuifbalk aanzetten?'
                content={<p>Dit onderzoek heeft al antwoorden die met rondjes zijn gegeven. Zet je de schuifbalk nu aan, dan vergelijk je straks twee soorten antwoorden met elkaar.</p>}
            />
            <ReadOnlyGuard edit="measurement.edit">
              {(canEdit) => (
            <div id='research-details-container'>
                {researches && researches.map(research => (
                    <div id='research-details-item-container' key={research.ID}>
                        <div className="table-container dashboard-container">
                            <h3>Titel</h3>
                            <input type="text" data-docid={research.docid} defaultValue={research.Title} onChange={changeResearchTitle} />
                        </div>

                        <div className="table-container dashboard-container">
                            <h3>Doelgroep</h3>
                            <table>
                                <tbody>
                                    <tr>
                                        <th>TITEL</th>
                                    </tr>
                                    <tr>
                                        <td> 
                                            <div className='edit-type-container'>
                                                {research.TargetgroupID 
                                                ?
                                                    <TargetgroupMeta targetgroupID={research.TargetgroupID}/>
                                                :
                                                    <p>Nog geen doelgroep geselecteerd</p>
                                                }
                                                {canEdit && (
                                                    <Tooltip content={'Doelgroep selecteren'}  top='-60px'>
                                                        <EditIcon onClick={() => editTargetgroup === 'none' ? setEditTargetgroup('block') : setEditTargetgroup('none')}/>
                                                    </Tooltip>
                                                )}
                                            </div>
                                            {/* Controlled: `defaultValue` wordt alleen bij het aanhaken gelezen,
                                                en dan zijn de doelgroepen nog onderweg — er is dan geen optie om te
                                                selecteren, dus valt het menu leeg terug en blijft dat zo. */}
                                            <select name="" id="" data-docid={research.docid} value={research.TargetgroupID || ''} onChange={changeTargetgroupHandler} style={{display:editTargetgroup}}>
                                                <option value="">-- Selecteer een doelgroep --</option>
                                                {stakeholders && stakeholders.map(item => (
                                                    <option key={item.ID} value={item.ID} data-title={item.Organisation} >{item.Organisation}</option>
                                                ))}
                                            </select>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="table-container dashboard-container" >
                            <h3>Meetmomenten</h3>
                            <MeasureMoment research={research} measureMoments={measureMoments}/>
                            <div className='add-item-table-row-container'>
                                {canEdit && (
                                    <Tooltip content={'Meetmoment toevoegen'} width={'200px'} top='-45px'>
                                        <img
                                        className='add-item-button'
                                        data-questionnaireid={research.QuestionnaireID}
                                        src={plusButton} alt=""
                                        data-researchid={research.ID}
                                        data-researchtitle={research.Title}
                                        onClick={addMoment}
                                        />
                                    </Tooltip>
                                )}
                            </div>
                            {canEdit && (
                                <p className='table-delete-icon' data-docid={research.docid} onClick={deleteResearch} src={deleteIcon} alt="" />
                            )}
                        </div>

                        <div className="table-container dashboard-container" style={{display: measureMoments.length > 0 ? 'block' : 'none'}}>
                            <h3>Vragenlijst</h3>
                            <div className='edit-type-container'>
                                {/* Controlled, om dezelfde reden als het doelgroepmenu hierboven:
                                    na een herlaadactie komen de vragenlijsten ná het onderzoek binnen. */}
                                <select name="" id="" onChange={selectQuestionnaire} data-researchdocid={research.docid} value={research.QuestionnaireID || ''}>
                                    <option value="">-- Selecteer een vragenlijst --</option>
                                    {questionnaires && questionnaires.map(item => (
                                        <option
                                            key={item.ID}
                                            value={item.ID}
                                            data-id={item.ID}
                                            data-researchdocid={research.docid}
                                            data-title={item.Title}
                                        >
                                            {item.Title} {item.ID === research.QuestionnaireID && `(${questionCountLabel(item.ID)})`}
                                        </option>
                                    ))}
                               </select>
                                {research.QuestionnaireID && (
                                    <Tooltip content={'Vragenlijst bewerken'} top='-60px'>
                                        <EditIcon className='edit-questionnaire-icon' onClick={() => history.push(`/${client}/questionairebuilder/${research.QuestionnaireID}/${research.ID}`)}/>
                                    </Tooltip>
                                )}
                            </div>

                              
                        </div>
 
                        <div className="dashboard-container">
                            <h3>Instellingen</h3>

                            {/* Voor wie geldt dit onderzoek — per module één schakelaar.
                                AI-CONTEXT: See docs/features/automatische-deelname-onderzoek.md */}
                            <ResearchAppliesToSettings research={research} />

                            <div className='research-settings-group'>
                            <h4 className='research-settings-group-title'>Invullen</h4>

                            {AIinterviewerOn && (
                                <>
                                    {/* AI Interviewer — achter de organisatie-vlag
                                        CompagnyMeta.AIinterviewer, want elke beurt kost
                                        spraakherkenning, een taalmodel en een stem. */}
                                    <div className='reasearch-builder-option-container'>
                                        <div className='research-builder-options-title-container'>
                                            <p><b>AI Interviewer</b></p>
                                            <p>Decca voert het gesprek: de respondent praat en Decca stelt de vragen, in plaats van zelf invullen</p>
                                        </div>
                                        <ToggleButton
                                            docid={research.docid}
                                            id="AIInterviewer"
                                            value={research.AIInterviewer || 'false'}
                                            collection="Research"
                                        />
                                    </div>

                                    {/* Geanimeerde voortgangsbalk, met de mini animatie
                                        als onderdeel: één schakelaar. Kan samen met
                                        de AI Interviewer; de mini animatie speelt dan
                                        stil niet (miniGameBlocked in QuestionnaireOpen). */}
                                    <div className='reasearch-builder-option-container'>
                                        <div className='research-builder-options-title-container'>
                                            <p><b>Geanimeerde voortgangsbalk</b></p>
                                            <p>Toon een geanimeerde voortgangsbalk en een mini animatie na het invullen van een vraag</p>
                                        </div>
                                        <ToggleButton
                                            docid={research.docid}
                                            id="ProgressBar"
                                            value={research.ProgressBar || 'false' }
                                            collection="Research"
                                        />
                                    </div>
                                    </>
                            )}
                        
                             {/* Vragen voorlezen */}
                            <div className='reasearch-builder-option-container'>
                                <div className='research-builder-options-title-container'>
                                    <p><b>Vragen voorlezen</b></p>
                                    <p>Toon een icoon bij iedere vraag waarop geklikt kan worden om de vragen voor te lezen</p>
                                </div>
                                <ToggleButton
                                    docid={research.docid}
                                    id="ReadAloud"
                                    value={research.ReadAloud || 'false'}
                                    collection="Research"
                                />
                            </div>

                            {/* Schuifbalk (Visual Analog Scale) in plaats van rondjes.
                                AI-CONTEXT: See docs/features/vas-slider.md */}
                            <div className='reasearch-builder-option-container'>
                                <div className='research-builder-options-title-container'>
                                    <p><b>Schuifbalk in plaats van rondjes</b></p>
                                    <p>Toon bij schaal- en matrixvragen een vrije schuifbalk. Kies dit vóór de eerste meting, anders vergelijk je twee soorten antwoorden</p>
                                    {/* De AI Interviewer stelt de vragen hardop en kent geen
                                        schuifbalk; zonder deze regel zag niemand dat
                                        (testronde 2026-10-15, B1). */}
                                    {AIinterviewerOn && isFlagOn(research.AIInterviewer) && isFlagOn(research.VisualAnalogScale) && (
                                        <p className='research-builder-option-note'>In een gesprek met de AI Interviewer is er geen schuifbalk. Zet de AI Interviewer voor een link uit om hem te gebruiken.</p>
                                    )}
                                </div>
                                <ToggleButton
                                    docid={research.docid}
                                    id="VisualAnalogScale"
                                    value={research.VisualAnalogScale || 'false'}
                                    collection="Research"
                                    confirmBeforeOn={() => confirmVasOn(research.ID)}
                                />
                            </div>
                            </div>

                             {/* Resultaten downloaden */}
                             {/* <div className='reasearch-builder-option-container'>
                                <div className='research-builder-options-title-container'>
                                    <p><b>Resultaten downloaden</b></p>
                                    <p>Laat repondenten een kopie van de resultaten downloaden na het afronden van de vragenlijst.</p>
                                </div>
                                <ToggleButton
                                    docid={research.docid}
                                    id="SendCopyOption"
                                    value={ normalize(research.SendCopyOption) }
                                    collection="Research"
                                />
                            </div> */}

                        </div>
                            
                    </div>
                ))}
            </div>
              )}
            </ReadOnlyGuard>
        </div>
    </div>
  )
}

export default ResearchBuilder
